import axios from 'axios'
import gql from 'graphql-tag'

import { onLogin, onLogout, client as apolloClient } from '@/vue-apollo'

class Auth {
  async autologin(email, hash, issued, ttl) {
    const {
      data: {
        autoLogin: {
          token: jwt,
          user: { ecpId }
        }
      }
    } = await apolloClient.mutate({
      mutation: gql`
        mutation autoLogin($email: String!, $hash: String!, $issued: Int!, $ttl: Int!) {
          autoLogin(email: $email, hash: $hash, issued: $issued, ttl: $ttl) {
            token
            user {
              ecpId
            }
          }
        }
      `,
      variables: {
        email,
        hash,
        issued,
        ttl
      }
    })

    await onLogin(apolloClient, jwt)
    return { ecpId, jwt }
  }

  async login(email, password) {
    const {
      data: { ecpId, jwt }
    } = await axios.post(`/auth/local-login`, {
      email: email,
      password: password
    })

    await onLogin(apolloClient, jwt)

    return { ecpId, jwt }
  }

  async loginWithToken(token) {
    await onLogin(apolloClient, token)
  }

  async logout() {
    // TODO - api post
    await onLogout(apolloClient)
  }
}

const auth = new Auth()

export default auth
